<template>
  <div>
    <cabecalho-pagina
      :titulo="$t('modulos.modelo_instrumento.servico.titulos.pecas')"
      :total-registros="tabela.quantidadeItens"
      :titulo-botao-novo="
        $t('modulos.modelo_instrumento.servico.botoes.adicionar_peca')
      "
      :sem-botao-ok="
        !buscarPermissao('ModeloInstrumento', 'Inserir') ||
        !buscarPermissao('ModeloInstrumento', 'EditarPecas')
      "
      :tem-tags="true"
      :valor-tags="badges"
      @abrirNovo="abrirModal"
      @filtrar="filtrar"
    >
      <template v-slot:filtro="{ filtro }">
        <filtroServico :filtro="filtro" />
      </template>
    </cabecalho-pagina>
    <div class="d-flex">
      <botao-padrao
        v-if="mostrarBotaoExcluir"
        class="my-2"
        outlined
        color="danger"
        @click="excluirRegistros"
      >
        <v-icon>$mdiTrashCanOutline</v-icon>
        {{ $t('geral.botoes.excluir') }}
      </botao-padrao>
    </div>
    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      class="mt-2"
      :colunas="tabela.colunas"
      mostra-header
      :dados="tabela.dados"
      :mostrar-acoes="false"
      :mostrar-seletor="buscarPermissao('ModeloInstrumento', 'EditarPecas')"
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :quantidade-paginas="tabela.quantidadePaginas"
      :pagina="tabela.paginaAtual"
      ajustar-altura-linha
      filtros-com-colunas
      @paginar="listarRegistros"
      @filtrarGlobal="listarRegistros"
      @filtroGlobal="(v) => (filtroAplicado.filter = v)"
      @nova-ordenacao="ordenacaoColuna"
    />
    <div class="d-flex align-center justify-end" style="padding-bottom: 20px">
      <botao-padrao outlined color="secondary" class="mr-2" @click="voltar">
        <v-icon>$mdiArrowLeft</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>
    </div>
    <AdicionarPecaModal
      ref="adicionar-peca-modal"
      :modelo-instrumento-id="id"
      :tipo-instrumento-id="tipoInstrumentoId"
      @atualizar-pagina="listarRegistros"
    />
  </div>
</template>
<script>
import CabecalhoPagina from '@components/layout/CabecalhoPagina.vue';
import ServicoInstrumentoService from '@common/services/cadastros/ServicoInstrumentoService';
import ModeloInstrumentoService from '@common/services/cadastros/ModeloInstrumentoService.js';
import AdicionarPecaModal from './components/modais/AdicionarPecaModal.vue';
import filtroServico from './filtroServico.vue';
import helpers from '@common/utils/helpers';

export default {
  components: {
    CabecalhoPagina,
    filtroServico,
    AdicionarPecaModal,
  },
  props: {
    id: { type: [String, Number], default: null },
  },
  data() {
    return {
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.modelo_instrumento.servico.tabela.peca'),
            sortable: true,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.modelo_instrumento.servico.tabela.nome'),
            sortable: true,
          },
          {
            value: 'participanteFabricante.nome',
            text: this.$t(
              'modulos.modelo_instrumento.servico.tabela.fabricante'
            ),
            sortable: true,
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
      },
      filtroAplicado: { filter: '' },
      erros: [],
      colunaOrdenada: '',
      tipoInstrumentoId: null,
      badges: [],
    };
  },
  computed: {
    podeExcluir: function () {
      return this.tabela.selecionados.length > 0;
    },
    mostrarBotaoExcluir() {
      return (
        this.podeExcluir &&
        this.buscarPermissao('ModeloInstrumento', 'EditarPecas')
      );
    },
  },
  mounted: async function () {
    if (this.id) {
      this.buscar(this.id);
    }
  },
  methods: {
    buscarPermissao(funcionalidade, funcionalidadeAcao) {
      return helpers.buscarStatePermissoes(
        this,
        funcionalidade,
        funcionalidadeAcao
      );
    },
    filtrarGlobal() {
      this.listarRegistros();
    },
    filtrar: function (filtro) {
      this.filtroAplicado = { ...filtro, filter: this.filtroAplicado.filter };
      this.$refs.tabela.atualizarPaginaAtual();
      this.listarRegistros(1);
    },
    listarRegistros: function (
      paginaAtual = this.tabela.paginaAtual,
      porPagina = this.tabela.porPagina
    ) {
      this.tabela.porPagina = porPagina;

      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        ...helpers.formattingParameters(this.filtroAplicado),
        sort: this.colunaOrdenada,
        modeloInstrumentoId: this.id,
        tipoInstrumentoId: this.tipoInstrumentoId,
      };

      this.$store.dispatch('Layout/iniciarCarregamento');
      this.tabela.dados = [];
      ServicoInstrumentoService.listarPecas(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items;
          this.tabela.quantidadeItens =
            res.data.totalItems ?? this.tabela.dados.length;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscar: function () {
      this.$store.dispatch('Layout/iniciarCarregamento');
      ModeloInstrumentoService.buscar(this.id)
        .then((res) => {
          this.badges = [
            { Tipo: res.data.tipoInstrumento?.nome },
            { Modelo: res.data.nome },
            { Marca: res.data.marca?.nome },
          ];
          this.tipoInstrumentoId = res.data.tipoInstrumento?.id;
        })
        .catch(() => {
          this.toastErro(
            this.$t('modulos.modelo_instrumento.erros.id_invalido')
          );
        })
        .finally(() => {
          this.listarRegistros();
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    excluirRegistros: function () {
      this.confirmarExcluir().then(() => {
        let parametros = {
          itemId: null,
          tipoInstrumentoId: this.tipoInstrumentoId,
          modeloInstrumentoId: this.id,
        };

        this.$store.dispatch('Layout/iniciarCarregamento');
        this.tabela.selecionados.forEach((item) => {
          parametros.itemId = item.id;

          ServicoInstrumentoService.excluirPecas(parametros)
            .then(() => {
              this.listarRegistros(
                this.tabela.paginaAtual,
                this.tabela.porPagina
              );
              this.toastSucesso(
                this.$t(
                  'modulos.modelo_instrumento.servico.exclusao_peca_sucesso'
                )
              );
              this.tabela.selecionados = [];
            })
            .finally(() => {
              this.$store.dispatch('Layout/terminarCarregamento');
            });
        });
      });
    },
    abrirModal: function () {
      this.$refs['adicionar-peca-modal'].abrirModal();
    },
    ordenacaoColuna(ordem) {
      this.colunaOrdenada = ordem;
      this.listarRegistros();
    },
    faixaFormatada(value) {
      return String(value).replaceAll('.', ',');
    },
    voltar: function () {
      this.$router.back();
    },
  },
};
</script>
<style>
.p-paginator {
  padding: 0.5rem 1rem !important;
}
</style>
